import React, { memo } from 'react'
import { BWCopyrightText } from 'src/libs/qb-brand-web-components'

const CopyrightText = ({ fontSize, brandName }) => {
  return <BWCopyrightText fontSize={fontSize} brandName={brandName} />
}

export default memo(CopyrightText)
